<template>
  <v-app id="app">
    <NavBar />

    <v-content class="ma-5">
      <v-container>
        <router-view></router-view>
      </v-container>
    </v-content>

    <v-footer dark color="grey darken-3" class="d-print-none">
      <span>&copy; 2020 Carles Barrobés</span>
    </v-footer>
  </v-app>
</template>

<script>
import NavBar from "@/components/NavBar.vue";

export default {
  props: {
    source: String
  },
  components: {
    NavBar
  },
  computed: {
    showDrawer() {
      return this.drawer;
    }
  }
};
</script>

<style>
#app {
  background-color: #f1f8e9; /* light-green lighten-5 */
  background-repeat: repeat;
  background-image: url(assets/img/miniguitarists-small-gray.png);
}
#app,
.v-app-bar {
  min-width: 360px;
}
</style>
